import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    inventory_lot_note: {
      ...jsConn.formParams,
    },
  };
};

const itemDetails = {
  pluralName: "inventory_lot_notes",
  singularName: "inventory_lot_note",
};

async function needInventoryLotNotes(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    return Promise.resolve(jsConn);
  });
}

async function createInventoryLotNote(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .createItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      return Promise.resolve(jsConn);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function deleteInventoryLotNote(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api
    .deleteItem(jsConn, itemDetails)
    .then(jsConn => {
      return Promise.resolve(jsConn);
    })
    .catch(jsConn => {
      return Promise.reject(jsConn);
    });
}

export const inventoryLotNotesController = {
  createInventoryLotNote,
  needInventoryLotNotes,
  deleteInventoryLotNote,
};
